export default __webpack_public_path__ + "static/media/front-right.c1b5c81b.png";